import 'regenerator-runtime/runtime';
import { call, put, select } from 'redux-saga/effects';

import API, { methods } from '../canvas-api';

import { handleGenericError, getAuthState } from '../common';
import { actions } from '../../reducers/auth/auth';

export default function* deleteAccount(action) {
  try {
    const { userId } = yield select(getAuthState);

    const response = yield call(API, {
      method: methods.DELETE,
      path: `users/${userId}`,
    });
    if (response === null) return;

    yield put(actions.deleteAccountSuccess());
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
